import React, { useState, useEffect } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useContentSelector } from '@wajeez-web/stores/content';
import { TextInput, NumberInput } from '@wajeez-web/components/ui';

export type Input = {
  id?: number;
  name: string;
  passingGrade: number;
};

const quizInitState: Input = {
  id: 0,
  name: '',
  passingGrade: 0,
};

const QuizzesModal: React.FC<CommonModalProps<Input | undefined>> = ({
  isOpen,
  onClose,
  data,
  onSubmit,
}) => {
  const [quiz, setQuiz] = useState<Input>(quizInitState);

  const create = useContentSelector((s) => s.quizzes.create);

  const update = useContentSelector((s) => s.quizzes.update);

  useEffect(() => {
    if (data) {
      setQuiz({ ...data });
    } else {
      setQuiz(quizInitState);
    }
  }, [data]);

  return (
    <Modal
      title="Quiz"
      withScroll={true}
      open={isOpen}
      onClose={onClose}
      loading={create.status === 'loading' || update.status === 'loading'}
      onSubmit={() => onSubmit && onSubmit({ ...quiz })}
      handleAlert={false}
      alertTarget="modal"
    >
      <div className="space-y-3">
        <TextInput
          label="Name"
          name="name"
          value={quiz.name}
          onChange={(name, value) => setQuiz({ ...quiz, name: value })}
          required={true}
        />
        <NumberInput
          label="Passing Grade"
          name="passingGrade"
          value={quiz.passingGrade}
          onChange={(name, value) =>
            setQuiz({ ...quiz, passingGrade: Number(value) })
          }
          required={true}
        />
      </div>
    </Modal>
  );
};

export default QuizzesModal;
